// Based on https://github.com/reactjs/react-rails/blob/83b6175460b6fd19d667854ebea4777d8c73705a/react_ujs/index.js

import React from 'react';
import ReactDOM from 'react-dom';
import { flattenRegistry } from 'shared/utils/flatten_registry';
import timeInDevelopment from 'shared/utils/time_in_development';

const CLASS_NAME_ATTR = 'data-react-class';
const PROPS_ATTR = 'data-react-props';

let mountedComponentsCount = 0;

class Mounter {
  constructor(componentRegistry) {
    this.componentRegistry = componentRegistry;
  }

  findDomNodes = () => {
    return this.reactNodes().filter((reactNode) => {
      const componentName = reactNode.getAttribute(CLASS_NAME_ATTR);
      return this.registeredComponentNames().includes(componentName);
    });
  };

  reactNodes(selector = '') {
    // It's possible in certain browsers for nodes to not have the iterable methods, so coerce into an Array
    return Array.prototype.slice.call(
      document.querySelectorAll(`${selector} [${CLASS_NAME_ATTR}]`)
    );
  }

  registeredComponentNames = () => {
    return Object.keys(this.flattenedRegistry());
  };

  getComponentConstructor = (className) => {
    return this.flattenedRegistry()[className];
  };

  flattenedRegistry = () => {
    this._flattenedRegistry =
      this._flattenedRegistry || flattenRegistry(this.componentRegistry);
    return this._flattenedRegistry;
  };

  mount = (node) => {
    mountedComponentsCount += 1;

    const className = node.getAttribute(CLASS_NAME_ATTR);

    timeInDevelopment(
      `Component mount #${mountedComponentsCount}: ${className}`,
      () => {
        const constructor = this.getComponentConstructor(className);
        const propsJson = node.getAttribute(PROPS_ATTR);
        const props = propsJson && JSON.parse(propsJson);

        ReactDOM.render(React.createElement(constructor, props), node);
      }
    );
  };

  mountAll = () => this.findDomNodes().forEach(this.mount);
}

export default Mounter;
